// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"65307385","344":"736ce7d2"}[chunkId] + ".chunk.css";
};